import React from "react";
import PropTypes from "prop-types";
import IconGlyph from "@/bit/components/components.icon-glyph";
import TextInfo from "@/bit/components/components.text";
import Label from "@/bit/components/components.cms-block.cms-label";

/**
 * Componente que permite crear el título para las cards de detalle
 */
function DetailCardTitle({ detailCardTitleProps, cmsHandler }) {

  const {
    "cms-atom-icon-1": iconProps,
    "cms-atom-text-1": textProps,
    "cms-atom-label-refactor-1": labelProps,
    layout,
    cms
  } = detailCardTitleProps;

  return (
    <>
      <div className="detail-card-title">
        {cmsHandler && (
          <span
            className={"element-editable block edit-component"}
            onClick={cms && cmsHandler ?
              () => cmsHandler({
                ...detailCardTitleProps,
                name: 'cms-block.cms-detail-card-title'
              }) : null}
          >
            <IconGlyph id="lapiz-m" height={20} color="white" />
          </span>
        )}
        <Label {...labelProps} cmsHandler={cmsHandler} />
        <div className={`title-icon layout-${layout ? layout : 'row'}`}>
          <div
            className={`${
              iconProps &&
              iconProps.id &&
              iconProps.width !== "0"
                ? "icon-gap"
                : ""
            }`}
          >
            <IconGlyph 
            {...iconProps}
            cmsHandler={cmsHandler}
            />
          </div>
          <TextInfo {...textProps} cmsHandler={cmsHandler} />
        </div>
      </div>
      <style jsx>{`.detail-card-title {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  .title-icon {
    display: flex;
    .icon-gap {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      min-height: 32px;
      min-width: 36px;
      border-radius: 50%;
      margin-right: 0.75rem;
    }
    :global(.text) {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    &.layout-column {
      flex-direction: column;
      align-items: flex-start;
    }
    &.layout-row {
      align-items: stretch;
    }
  }
}
`}</style>
    </>
  );
}

DetailCardTitle.propTypes = {
  /**
   * {
   *  "info": "Layout del título. Controla la disposición del texto y el icono",
   *  "kind": "both",
   *  "beautifulName": "Layout",
   *  "values": "./enums.js:LAYOUT_TYPES"
   * }
   */
  layout: PropTypes.string
};

DetailCardTitle.defaultProps = {
  layout: "row"
};

export default DetailCardTitle;
